// Customize consent here
const logoUrl = '//gw7ucr2w2l2o2c68-26030288.shopifypreview.com/cdn/shop/t/84/assets/agecheckerVsARddsz9-logo_image_300x.png?v=148907328988844681091714404061'
const text = 'You <strong>MUST</strong> be 19 years or older to enter and order from U Vape. We do not sell vape or 420 products to minors, and <strong>ALL</strong> orders will be subject to age verification.'
const cookieName = 'uvape_ageverification'
// END Customize consent here

const getCookie = (name) => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
}

const calcAge = (dateString) => { 
  var today = new Date();
  var birthDate = new Date(dateString);
  var age = today.getFullYear() - birthDate.getFullYear();
  var m = today.getMonth() - birthDate.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }
  return age;
}

const agePassed = localStorage.getItem(cookieName) || getCookie(cookieName)

document.addEventListener('DOMContentLoaded', function () {
  if (!agePassed) {
    const body = document.querySelector('body')
    const ageModal = `
      <div class="agemodal__overlay">
      <div class="agemodal">
        <div class="agemodal__inner">
          <img src="${logoUrl}" class="agemodal__logo">
          <h2 class="agemodal__title">Please confirm your age</h2>
          <p>${text}</p>
          <div class="agemodal__actions">
            <label for="agemodalDate" class="agemodal__label">Please enter your birthday:</label>
            <input type="date" name="agemodalDate" id="agemodalDate" class="agemodal__date" value="2000-01-01" min="1920-01-01">
            <button class="agemodal__button button-primary" id="agemodalBtn">Submit</button>
          </div>
          <p class="agemodal__no" style="display:none;" id="ageconsentNoText">Sorry, your age does not permit you to enter at this time.</p>
          <p class="agemodal__small">By entering this site you are agreeing to our Terms of Use and Privacy Policy. U Vape Friendly Vape Shop. ALL ORDERS WILL REQUIRE PROOF OF AGE</p>
        </div>
      </div>
    `
    
    body.insertAdjacentHTML('beforeend', ageModal)    
    
    const date = document.getElementById('agemodalDate')
    const btn =  document.getElementById('agemodalBtn')
    
    date.max = new Date().toISOString().split('T')[0]

    btn.addEventListener('click', () => {
      if (calcAge(date.value) >= 19) {
        document.cookie = `${cookieName}=1; max-age=31536000; path=/;`
        localStorage.setItem(cookieName, 1)

        document.querySelector('.agemodal__overlay').remove()
        document.querySelector('.agemodal').remove()
      
      } else {
        document.getElementById('ageconsentNoText').style.display = 'block'
        date.disabled = true
        btn.disabled = true
      }
    })    
  }
})

